import { Link, useLocation } from "react-router-dom";
import { useLanguage, LANGS } from "../context/LanguageContext";

export default function LangSwitcher({ className = "" }) {
  const { lang, setLang } = useLanguage();
  const location = useLocation();

  const parts = location.pathname.split("/").filter(Boolean);
  if (parts.length && LANGS.includes(parts[0])) parts.shift();
  const cleanPath = "/" + parts.join("/");

  const toFor = (code) => (code === "en" ? cleanPath : `/${code}${cleanPath === "/" ? "" : cleanPath}`);

  return (
    <div
      data-testid="language-switcher"
      className={`flex items-center rounded-full border border-white/15 bg-white/5 backdrop-blur p-0.5 ${className}`}
    >
      {LANGS.map((code) => (
        <Link
          key={code}
          to={toFor(code)}
          data-testid={`lang-option-${code}`}
          aria-pressed={lang === code}
          onClick={() => setLang(code)}
          className={`px-3 py-1.5 rounded-full font-mono2 text-[11px] tracking-[0.15em] transition-all duration-300 ${
            lang === code ? "bg-gold text-black font-semibold" : "text-slate-300 hover:text-gold-soft"
          }`}
        >
          {code.toUpperCase()}
        </Link>
      ))}
    </div>
  );
}
